import {Photo} from 'data/records'
import {resource, collection, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(Photo, [
  ['create', collection.post('', ['parentId', 'parentType', 'file'])]
])

const selectors = {
  ...findSelector(Photo)
}

const reducers = {}

const initialState = {}

export {
  api as photoApi,
  actions as photoActions,
  selectors as photoSelectors,
  reducers as photoReducers,
  initialState as photoInitialState
}
